var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nc-container',{attrs:{"id":"appHeader"}},[_c('nc-row',[_c('nc-column',[_c('h1',[_vm._v(_vm._s(_vm.title))])])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }